








































import Vue from 'vue'
import Component from 'vue-class-component'
import { Emit, Prop } from 'vue-property-decorator'

@Component
export default class LanguagePicker extends Vue {
  @Prop({ type: Array, default: () => [ 'en', 'ru' ] }) languageCodes!: Array<string> | null

  @Prop({ type: String }) currentLanguage!: string

  @Prop({ type: Boolean, default: false, required: false }) disabled!: boolean

  @Emit('onLocaleChange')
  onLocaleChange(localeCode:'ru' | 'en'): 'ru' | 'en' {
    return localeCode
  }

  isVisible = false

  getLanguageName(code: string): string {
    if (code === 'ru') {
      return 'Русский'
    }

    if (code === 'de') {
      return 'Deutsche'
    }

    return 'English'
  }

  // eslint-disable-next-line consistent-return,getter-return
  get getCurrentLocaleData(): any {
    const locale = this.currentLanguage
    if (locale === 'en') {
      return {
        flag: 'us',
        lang: 'English',
      }
    }
    if (locale === 'ru') {
      return {
        flag: 'ru',
        lang: 'Русский',
      }
    }
    if (locale === 'de') {
      return {
        flag: 'de',
        lang: 'Deutsche',
      }
    }
  }
}
